import axios, {AxiosError, CreateAxiosDefaults} from 'axios'
import LocalStorageResolver from '@/services/localStorageResolver'
import {AppDispatch, store} from '@/store'
import {SET_FAIL_LOAD, SET_LOAD} from '@/store/slices'
import router from '@/router'
import {refreshToken} from '@/store/actions/storage'
import {logoutUser} from '@/store/actions'

const jwt = LocalStorageResolver.getJwt
const language = LocalStorageResolver.langauge

const configAxios: CreateAxiosDefaults = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: `Bearer ${jwt}`,
    'Accept-Language': language,
    source: 'web-app',
  },
}

const httpClient = axios.create(configAxios)
const dispatch: AppDispatch = store.dispatch

let refreshTokenPromise: Promise<any> | null = null

httpClient.interceptors.request.use(
  (config) => {
    dispatch(SET_LOAD(true))
    return config
  },
  (error) => {
    dispatch(SET_LOAD(false))
    return Promise.reject(error)
  }
)

httpClient.interceptors.response.use(
  (response) => {
    dispatch(SET_LOAD(false))
    return response
  },
  async (error: AxiosError<{local_code?: number; message?: string}>) => {
    if (error?.response) {
      if (error.response.status === 401) {
        if (!refreshTokenPromise) {
          refreshTokenPromise = dispatch(refreshToken())
        }
        
        const response = await refreshTokenPromise
        refreshTokenPromise = null
        
        if (!response.payload) {
          await dispatch(logoutUser())
          router.navigate('/')
        }
      }

      if (error.response.status === 449) {
        if (window.location.pathname !== '/maintenance') {
          router.navigate('/maintenance')
        }
        return Promise.reject(error)
      }

      if (error.response.status === 500) {
        dispatch(SET_FAIL_LOAD(true))
      }
    }

    if (error?.response?.data) {
      const errorData = error.response.data
      if (errorData.local_code === 11100) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error 11100:', errorData.message)
        }
      }
      if (errorData.local_code === 10601) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error 10601:', errorData.message)
        }
      }
    } else if (!error?.response) {
      dispatch(SET_FAIL_LOAD(true))
    }

    dispatch(SET_LOAD(false))
    if (error.response) {
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export default httpClient
